import { getApiBaseUrl } from '../../utils/environment.mjs';
// src/services/uploadService.js
import axios from 'axios';

const API_BASE_URL = getApiBaseUrl();

export const uploadService = {
  // Upload MIE breakdown data
  uploadMieBreakdown: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      
      const response = await axios.post(`${API_BASE_URL}/mie/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to upload MIE breakdown data' };
    }
  },
  
  // Upload per diem country data
  uploadPerDiemCountry: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      const response = await axios.post(`${API_BASE_URL}/perdiem/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to upload per diem country data' };
    }
  }
};

